import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthenticationService} from '../services/authentication/authentication.service';

@Injectable({providedIn: 'root'})
export class SubscriptionsTypeResolver implements Resolve<Object> {
  constructor(private authenticationService: AuthenticationService) {
  }

  resolve(
    route: ActivatedRouteSnapshot,
  ): Observable<any> | Promise<any> | any {
    const subscriptionTypes = [
      {
        name: 'SENCEIVE',
        value: 1,
        keyUrl: 'senceive'
      },
      {
        name: 'CSV-SFTP',
        value: 2,
        keyUrl: 'csv-sftp'
      },
      {
        name: 'NEWSTEO',
        value: 3,
        keyUrl: 'newsteo'
      }
    ];
    if (this.authenticationService.currentUserCanManageMathsModules()) {
      subscriptionTypes.push(
        {
          name: 'EVENTDYN',
          value: 4,
          keyUrl: 'eventdyn'
        },
        {
          name: 'MODULE_MATHS_THERMAL_CORRECTION',
          value: 5,
          keyUrl: 'thermal-correction'
        },
      );
    }
    return subscriptionTypes;
  }
}
